import { __rest } from "tslib";
import SlickCarousel from '@ant-design/react-slick';
import classNames from 'classnames';
import * as React from 'react';
import LeftOutlined from '@haier/icons/LeftOutlined';
import RightOutlined from '@haier/icons/RightOutlined';
import { ConfigContext } from '../config-provider';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
const Carousel = React.forwardRef((_a, ref) => {
    var { dots = true, arrows = false, draggable = false, dotPosition = 'bottom', vertical = dotPosition === 'left' || dotPosition === 'right' } = _a, props = __rest(_a, ["dots", "arrows", "draggable", "dotPosition", "vertical"]);
    useBuriedPoint('Carousel');
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const slickRef = React.useRef();
    const goTo = (slide, dontAnimate = false) => {
        slickRef.current.slickGoTo(slide, dontAnimate);
    };
    React.useImperativeHandle(ref, () => ({
        goTo,
        autoPlay: slickRef.current.innerSlider.autoPlay,
        innerSlider: slickRef.current.innerSlider,
        prev: slickRef.current.slickPrev,
        next: slickRef.current.slickNext,
    }), [slickRef.current]);
    const prevCount = React.useRef(React.Children.count(props.children));
    React.useEffect(() => {
        if (prevCount.current !== React.Children.count(props.children)) {
            goTo(props.initialSlide || 0, false);
            prevCount.current = React.Children.count(props.children);
        }
    }, [props.children]);
    const newProps = Object.assign({ vertical }, props);
    if (newProps.effect === 'fade') {
        newProps.fade = true;
    }
    const prefixCls = getPrefixCls('carousel', newProps.prefixCls);
    const dotsClass = 'slick-dots';
    const enableDots = !!dots;
    const dsClass = classNames(dotsClass, `${dotsClass}-${dotPosition}`, typeof dots === 'boolean' ? false : dots === null || dots === void 0 ? void 0 : dots.className);
    const className = classNames(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-vertical`]: dotPosition === 'left' || dotPosition === 'right',
    });
    const nextArrowDom = arrows ? (React.createElement("div", { className: `${prefixCls}-next-arrow` },
        React.createElement(RightOutlined, null))) : undefined;
    const prevArrowDom = arrows ? (React.createElement("div", { className: `${prefixCls}-prev-arrow` },
        React.createElement(LeftOutlined, null))) : undefined;
    return (React.createElement("div", { className: className },
        React.createElement(SlickCarousel, Object.assign({ ref: slickRef }, newProps, { dots: enableDots, dotsClass: dsClass, arrows: arrows, draggable: draggable, nextArrow: nextArrowDom, prevArrow: prevArrowDom }))));
});
export default Carousel;
